import React, { useState, useEffect } from "react";
import TimeTableGridView from "./gridView/TimeTableGridView";
import TimetableListView from "./listView/TimeTableListView";
import { Grid } from "react-feather";
import ApiConfig from "../../api/ApiConfig";
import { simplePostCall } from "../../api/ApiServices";
import Params from "../../config/Params";
import SpinnerCmp from "../../components/SpinnerCmp";
import { toast } from "react-toastify";
import TImeTableSkeleton from "../../components/skeletons/TImeTableSkeleton";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import useParams from "../../config/useParams";

const Timetable = (props) => {
  const { t } = useTranslation();
  const [params, setParams] = useParams();

  const [isloading, setIsLoading] = useState(true);
  const [classList, setClassList] = useState([]);
  const [class_division_id, setClass_division_id] = useState("");
  const [indicate, setIndicate] = useState("");
  const [timeTableByClass, setTimeTableByClass] = useState({
    TimetableByClass: [],
    PeriodsByClass: [],
  });

  const [timetableState, setTimetableState] = useState({
    myTimetable: [],
    Periods: [],
  });

  const getTimeTableByClass = () => {
    setIsLoading(true);
    let newRequestBody = JSON.stringify({
      customer_id: JSON.parse(localStorage.getItem("CUSTOMER_ID")),
      api_key: JSON.parse(localStorage.getItem("API_KEY")),
      division_id: class_division_id,
    });

    simplePostCall(ApiConfig.BY_CLASS_TIMETABLE, newRequestBody, params)
      .then((data) => {
        if (data?.result) {
          const periods_list =
            data.periods?.map((period) => ({
              id: period.periods_id,
              PeriodId: period.periods_name,
              startTime: period.periods_start_time,
              endTime: period.periods_end_time,
              isInterval: period.periods_type === "break",
            })) || [];

          setTimeTableByClass({
            TimetableByClass: data.my_timetable || [],
            PeriodsByClass: periods_list,
          });
        } else {
          toast.error(data?.message || "No time table available for this class");
          setTimeTableByClass({
            TimetableByClass: [],
            PeriodsByClass: [],
          });
        }
      })
      .catch((error) => {
        console.error("API error:", error);
        toast.error("Failed to load timetable data");
      })
      .finally(() => setIsLoading(false));
  };

  const getTimetableData = () => {
    setIsLoading(true);
    console.log('params--', params)
    let requestBody = JSON.stringify({
      api_key: JSON.parse(localStorage.getItem("API_KEY")),
      customer_id: JSON.parse(localStorage.getItem("CUSTOMER_ID")),
      teacher_id: JSON.parse(localStorage.getItem("TEACHER_ID")),
      date: "",
    });

    simplePostCall(ApiConfig.MY_TIMETABLE, requestBody, params)
      .then((data) => {
        if (data?.result) {
          const periods_list =
            data.periods?.map((period) => ({
              id: period.periods_id,
              PeriodId: period.periods_name,
              startTime: period.periods_start_time,
              endTime: period.periods_end_time,
              isInterval: period.periods_type === "break",
            })) || [];

          setTimetableState({
            myTimetable: data.my_timetable || [],
            Periods: periods_list,
          });
        } else {
          toast.error(data?.message || "Failed to load timetable");
        }
      })
      .catch((error) => {
        console.error("API error:", error);
        toast.error("Failed to load timetable data");
      })
      .finally(() => setIsLoading(false));
  };

  const getClassList = () => {
    let newRequestBody = JSON.stringify({
      customer_id: JSON.parse(localStorage.getItem("CUSTOMER_ID")),
      api_key: JSON.parse(localStorage.getItem("API_KEY")),
      user_id: JSON.parse(localStorage.getItem('user_id')),
    });

    simplePostCall(ApiConfig.CLASSES_LIST_API, newRequestBody, params)
      .then((data) => {
        if (data?.result) {
          setClassList(data.list || []);
        }
      })
      .catch((error) => {
        console.error("API error:", error);
      });
  };

  useEffect(() => {
    document.title = "YellowCalf | Timetable";
    if (params.api_key) {
      if (class_division_id) {
        getTimeTableByClass();
      } else {
        getTimetableData();
      }
      getClassList();
    }
  }, [class_division_id, params]);

  const [isGridView, setIsGridView] = useState(true);

  const dataGrid = {
    Periods: timetableState.Periods || [],
    Lectures: timetableState.myTimetable || {},
  };

  const dataGridByClass = {
    Periods: timeTableByClass.PeriodsByClass || [],
    Lectures: timeTableByClass.TimetableByClass || {},
  };

  return (
    <>
      {isloading ? (
        <TImeTableSkeleton />
      ) : (
        <div className="timetable">
          <div className="row">
            <div className="col-sm-12">
              <div className="d-flex">
                <h5 className="mb-2 flex-grow-1">{t("Timetable")}</h5>
                <a
                  onClick={() => setIsGridView(!isGridView)}
                  className="tt-align"
                >
                  {isGridView ? (
                    <i className="icofont icofont-listing-box"></i>
                  ) : (
                    <Grid />
                  )}
                </a>
              </div>
              <ul className="nav nav-pills" id="pills-tab" role="tablist">
                <li className="nav-item">
                  <a
                    className={
                      class_division_id ? "nav-link" : "nav-link active"
                    }
                    id="pills-home-tab"
                    data-bs-toggle="pill"
                    href="#pills-home"
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected="true"
                    onClick={() => {
                      setClass_division_id("");
                      setIndicate("");
                    }}
                  >
                    {t("My Timetable")}
                    <div className="media"></div>
                  </a>
                </li>

                {classList?.map((classItem, index) => (
                  <li className="nav-item" key={`classList-${index}`}>
                    <a
                      className={
                        index === indicate ? "nav-link active" : "nav-link"
                      }
                      id="pills-profile-tab"
                      data-bs-toggle="pill"
                      href="#pills-profile"
                      role="tab"
                      aria-controls="pills-profile"
                      aria-selected="false"
                      onClick={() => {
                        setClass_division_id(classItem.class_division_id);
                        setIndicate(index);
                      }}
                    >
                      {t("Class")} {classItem.class_name}{" "}
                      {classItem.class_division_name}
                    </a>
                  </li>
                ))}
                {/* <div className="top-btn-wrapper">
                <Link to="/TimeTableGenerate" 
                // className="generate-link"
                >
                  <h6>{t("Generate Time Table")}</h6>
                </Link>
                </div> */}
                <Link
                  to={`/TimeTableGenerate`}
                  style={{
                    marginLeft: 30,
                    //  padding:9,
                    width: "18%",
                    backgroundColor: "#adc927",
                    alignContent: "center",
                    borderRadius: 5,
                    color: "white",
                    textAlign: "center",
                    // marginTop: 10,
                  }}
                >
                  <h6 style={{ marginTop: 10, marginLeft: 12 }}>
                    {t("Generate Time Table")}
                  </h6>
                </Link>
              </ul>

              <div className="card mt-2 br-15">
                <div className="card-body">
                  <div className="tab-content" id="pills-tabContent">
                    <div
                      className="tab-pane fade show active"
                      id="pills-home"
                      role="tabpanel"
                      aria-labelledby="pills-home-tab"
                    >
                      {isGridView ? (
                        <TimeTableGridView
                          data={class_division_id ? dataGridByClass : dataGrid}
                        />
                      ) : (
                        <TimetableListView
                          data={class_division_id ? dataGridByClass : dataGrid}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Timetable;
